  import React from "react";
  import { useParams, useNavigate } from "react-router-dom";
  import "./Delice.css";
  import { imagesDelice, imagesDelichizz, imagesFrico, imagesUntadeli } from "../../../../assets/Categorias/images"; // Importar imágenes desde el archivo centralizado

  // Datos específicos de cada categoría (por ejemplo, para 'Delice')
  const categoriasData = {
    Delice: [
      { id: "qcrema", image: imagesDelice.qcrema, subtitle: "Quesos Crema" },
      { id: "qfresco", image: imagesDelice.qfresco, subtitle: "Quesos Fresco" },
      { id: "qmozarella", image: imagesDelice.qmozarella, subtitle: "Queso Mozarella" },
      { id: "qmantequilla", image: imagesDelice.Mantequilla, subtitle: "Mantequilla" },
      { id: "qmadurados", image: imagesDelice.madurados, subtitle: "Quesos Madurados" },
      { id: "qgourmet", image: imagesDelice.qgourmet, subtitle: "Queso Gourmet" },
      { id: "qdisp", image: imagesDelice.dips, subtitle: "Dips" },


    ],
    Delichizz: [
      {  id: "dmozzarella", image: imagesDelichizz.dmozarella, subtitle: "Tipo Mozzarella" },
      {  id: "dedam", image: imagesDelichizz.dEdam, subtitle: "Tipo Edam" },
      {  id: "dcrema", image: imagesDelichizz.dcrema, subtitle: "Tipo Queso Crema" }
    ],
    Untadeli: [
      { id: "ucrema", image: imagesUntadeli.ucrema, subtitle: "Crema Con Queso" },
      { id: "uuntable", image: imagesUntadeli.uuntable, subtitle: "Crema Untable" }
    ],
    Frico: [
      { id: "fmadurados", image: imagesFrico.fmadurados, subtitle: "Quesos Madurados" }
    ],
  };

  const Delice = () => {
    const { nombre } = useParams(); // Obtiene la categoría desde la URL
    const navigate = useNavigate(); // Para navegación
  
    const items = categoriasData[nombre] || []; // Obtiene las subcategorías
  
    const handleVerMas = (categoria, id) => {
      navigate(`/categoria/${categoria}/${id}`);
    };
  
    return (
      <div className="categoria-detalle-container">
        <h1 className="categoria-detalle-titulo">{nombre}</h1>
        <div className="categoria-detalle-grid">
          {items.map((item) => (
            <div key={item.id} className="detalle-cuadro">
              <img
                src={item.image}
                alt={item.subtitle}
                className="detalle-imagen"
                onClick={() => handleVerMas(nombre, item.id)}
              />
              <h3 className="detalle-subtitulo">{item.subtitle}</h3>
              <button
                className="detalle-boton"
                onClick={() => handleVerMas(nombre, item.id)}
              >
                Ver más
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default Delice;
